import { createRenderer, StylesProvider } from '@creditinfo-ui/styles';
import { IntlProvider } from 'react-intl';
import { useGlobalStyles } from './useGlobalStyles';
import EleringConsent from './pages/elering/EleringConsent';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import EleringReturn from './pages/elering/EleringReturn';
import React from 'react';

const renderer = createRenderer();

export const ConsentRoot = () => (
  <StylesProvider direction="ltr" renderer={renderer}>
    <IntlProvider locale="en">
      <ConsentApp />
    </IntlProvider>
  </StylesProvider>
);

const ConsentApp = () => {
  useGlobalStyles();

  return (
    <Router>
      <Routes>
        <Route path="/" element={<EleringConsent />} />
        <Route path="/consent" element={<EleringConsent />} />
        <Route path="/return" element={<EleringReturn />} />
        <Route path="*" element={<Navigate to="/" />}></Route>
      </Routes>
    </Router>
  );
};
